import FooterLink from "./footerLink";
import { useSelector } from "react-redux";
import { selectUserType } from "../../../features/authSlice";
import FooterSmall from "./footerSmall";
import { HashLink } from "react-router-hash-link";

const NavSection = () => {
  const userType = useSelector(selectUserType);

  return (
    <>
      {/* Desktop Navigation */}
      <div className="hidden lg:flex gap-8 xl:gap-16">
        {/* Features Column */}
        <div className="flex flex-col gap-4">
          <h2 className="font-semibold text-gray-900 mb-2">Features</h2>
          {userType === "tradie" && (
            <FooterLink title="Job Requests" to="/jobRequests" />
          )}
          <FooterLink title="Blogs" to="/blogs" />
          <FooterLink title="Services" to="/service" />
          {userType !== "client" && userType && (
            <FooterLink title="Professionals" to="professional" />
          )}
          {userType && (
            <FooterLink title="Subscriptions" to="/settings/subscriptions" />
          )}
          {!userType && (
            <HashLink
              className="text-gray-500 hover:text-primary transition-colors"
              smooth
              to="/#HomeSubscriptions"
            >
              Subscriptions
            </HashLink>
          )}
        </div>

        {/* Support Column */}
        <div className="flex flex-col gap-4">
          <h2 className="font-semibold text-gray-900 mb-2">Support</h2>
          <FooterLink title="Privacy Policy" to="privacyPolicy" />
          <FooterLink title="Terms Of use" to="termsOfUse" />
          <FooterLink title="Contact Us" to="contactUs" />
        </div>

        {/* Our Information Column */}
        <div className="flex flex-col gap-4">
          <h2 className="font-semibold text-gray-900 mb-2">Our Information</h2>
          <span className="text-gray-500">P.O.Box 434</span>
          <span className="text-gray-500">Mount Ommaney QLD. 4074</span>
          <a
            href="mailto:Support@hailingtrades.com"
            className="text-gray-500 hover:text-primary transition-colors"
          >
            Support@hailingtrades.com
          </a>
          <a
            href="tel:1800872337"
            className="text-gray-500 hover:text-primary transition-colors"
          >
            1800 872 337
          </a>
        </div>

        {/* Download App Column */}
        <div className="flex flex-col gap-4">
          <h2 className="font-semibold text-gray-900 mb-2">Download App</h2>
          <a
            href="https://play.google.com/store/apps/details?id=com.feur.hailingtrades&pcampaignid=web_share"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="googlePlay.png"
              className="w-32 cursor-pointer hover:opacity-80 transition-opacity"
              alt="Get it on Google Play"
            />
          </a>
          <a
            href="https://apps.apple.com/eg/app/hailing-trades/id6739243038"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="apple.png"
              className="w-32 cursor-pointer hover:opacity-80 transition-opacity"
              alt="Download on the App Store"
            />
          </a>
        </div>
      </div>

      {/* Mobile/Tablet Navigation */}
      <div className="lg:hidden flex flex-col">
        {/* Mobile App Store Buttons */}
        <div className="flex gap-4 justify-center my-6">
          <a
            href="https://play.google.com/store/apps/details?id=com.feur.hailingtrades&pcampaignid=web_share"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="googlePlay.png"
              className="w-32 cursor-pointer"
              alt="Get it on Google Play"
            />
          </a>
          <a
            href="https://apps.apple.com/eg/app/hailing-trades/id6739243038"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="apple.png"
              className="w-32 cursor-pointer"
              alt="Download on the App Store"
            />
          </a>
        </div>

        {/* Accordion Sections */}
        <FooterSmall title="Features">
          {userType === "tradie" && (
            <FooterLink title="Job Requests" to="/jobRequests" />
          )}
          <FooterLink title="Blogs" to="/blogs" />
          <FooterLink title="Services" to="/service" />
          {userType === "apprentice" && (
            <FooterLink title="Professionals" to="professional" />
          )}
          {userType && (
            <FooterLink title="Subscriptions" to="/userSubscription" />
          )}
          {!userType && (
            <HashLink
              className="text-gray-500 hover:text-primary transition-colors"
              smooth
              to="/#HomeSubscriptions"
            >
              Subscriptions
            </HashLink>
          )}
        </FooterSmall>

        <FooterSmall title="Support">
          <FooterLink title="Privacy Policy" to="privacyPolicy" />
          <FooterLink title="Terms Of use" to="termsOfUse" />
          <FooterLink title="Contact Us" to="contactUs" />
        </FooterSmall>

        <FooterSmall title="Our Information">
          <span className="text-gray-500">P.O.Box 434</span>
          <span className="text-gray-500">Mount Ommaney QLD. 4074</span>
          <a
            href="mailto:Support@hailingtrades.com"
            className="text-gray-500 hover:text-primary transition-colors"
          >
            Support@hailingtrades.com
          </a>
          <a
            href="tel:1800872337"
            className="text-gray-500 hover:text-primary transition-colors"
          >
            1800 872 337
          </a>
        </FooterSmall>
      </div>
    </>
  );
};

export default NavSection;
